<template>
    <div class="form-group first">
        <select name="area" v-model="form.field_id" class="form-control" required>
            <option :value="null" selected>Escolha uma área de atuação</option>
            <option v-for="field in fields" :key="field.id" :value="field.id">
                {{ field.name }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        data(){
            return {
            form: {
                field_id: null,
            },
                fields: [],
            }
        },
        mounted() {
            axios.get('/fields')
                .then(({data}) => {
                    this.fields = data;
                });
        }
    }
</script>
